import { createPortal } from 'react-dom';
import { requireLegacy } from '../../legacy/legacyGlobals';
import { flagSvg, LANGS } from './languages';

interface LanguageSheetProps {
  /** The currently selected language code. */
  currentCode: string;
  /** Closes the sheet (dim tap, or immediately before a language change applies). */
  onClose: () => void;
  /** Re-renders the host screen after the language change has applied. */
  onLanguageChanged: () => void;
}

/**
 * The language picker sheet (legacy openLangSheet): a body-level dim + sheet,
 * closed by tapping the dim. Choosing a language closes the sheet and routes
 * the change through the legacy runtime's setLanguage so its own in-memory
 * state, the stored preference, the fetched Qurʼan translation and the
 * document lang/dir all update exactly as before.
 */
export function LanguageSheet({ currentCode, onClose, onLanguageChanged }: LanguageSheetProps) {
  const t = requireLegacy('t');

  const chooseLanguage = (code: string) => {
    onClose();
    void requireLegacy('setLanguage')(code, onLanguageChanged);
  };

  return createPortal(
    <>
      <div className="langsheet-dim" onClick={onClose} />
      <div className="langsheet">
        {/* The original calls el('h4', t('langPick')) — two args, so the translated
            string lands in the CLASS attribute and the heading stays empty. Faithfully
            preserved: fixing it would visibly change the sheet. */}
        <h4 className={t('langPick')} />
        {LANGS.map((lang) => {
          const selected = lang.code === currentCode;
          return (
            <button key={lang.code} className={'langrow' + (selected ? ' on' : '')} onClick={() => chooseLanguage(lang.code)}>
              <span className="lflag" dangerouslySetInnerHTML={{ __html: flagSvg(lang.cc) }} />
              <span>{lang.name}</span>
              {selected && <span className="lcheck">✓</span>}
            </button>
          );
        })}
      </div>
    </>,
    document.body,
  );
}
